import { render, staticRenderFns } from "./FieldRoleUser.vue?vue&type=template&id=44b2e430&"
import script from "./FieldRoleUser.vue?vue&type=script&lang=js&"
export * from "./FieldRoleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports